// extracted by mini-css-extract-plugin
export var text = "_ai-0";